import { useEffect } from 'react';
import config from 'config';

import { PROD_APP_ID } from '../../../../constants/SnowplowConst';
import { applyRingEmbedScriptSource } from '../../../../utils/RingEmbedScript';

const useEmbedModule = ({
    eventId,
    eventUniqueName,
    containerRef,
    mainEventColor,
    moduleName,
    isWhitelabel,
    enabled = true,
}) => {
    useEffect(() => {
        if (!enabled || !containerRef.current || !eventUniqueName) {
            return;
        }

        const scriptElement = document.createElement('script');

        applyRingEmbedScriptSource(scriptElement, { eventId, eventUniqueName, isWhitelabel });

        if (config.namespace !== 'prod') {
            scriptElement.setAttribute('data-bz-namespace', config.namespace);
            scriptElement.setAttribute('data-bz-appid', `${PROD_APP_ID}-test`);
        } else {
            scriptElement.setAttribute('data-bz-appid', PROD_APP_ID);
        }

        scriptElement.setAttribute('data-bz-theme-colors', JSON.stringify({ main: mainEventColor }));

        scriptElement.setAttribute('data-bz-event-id', eventUniqueName);

        scriptElement.setAttribute('data-bz-modules', moduleName);

        containerRef.current.appendChild(scriptElement);

        return () => {
            if (containerRef.current && containerRef.current.contains(scriptElement)) {
                containerRef.current.removeChild(scriptElement);
            }
        };
    }, [enabled, eventUniqueName, containerRef, mainEventColor, moduleName]);
};

export default useEmbedModule;
